import { useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { Share2, Check } from "lucide-react";
import { API } from "../App";

// "Send 3 plays" — mints a share link for a HOARD track; the friend gets 3 full plays, then the unlock-your-HOARD prompt.
export const ShareTrackButton = ({ track, className = "", label, testId = "player-share-btn" }) => {
  const [done, setDone] = useState(false);
  const share = async () => {
    if (!track) return;
    try {
      const r = await axios.post(`${API}/hoard/share`, { item_id: track.item_id }, { withCredentials: true });
      const url = `${window.location.origin}/s/${r.data.share_id}`;
      const text = `${track.title} — ${track.artist_name} · ${r.data.plays} full plays on THE WALL, on me`;
      if (navigator.share) { try { await navigator.share({ title: track.title, text, url }); } catch { /* cancelled */ } }
      else { await navigator.clipboard.writeText(url); toast.success(`Link copied — your friend gets ${r.data.plays} full plays`); }
      setDone(true); setTimeout(() => setDone(false), 2500);
    } catch (e) { toast.error(e.response?.data?.detail || "Couldn't make a share link"); }
  };
  return (
    <button type="button" onClick={share} className={className} aria-label="Share this track — 3 full plays for a friend" title="Send a friend 3 full plays of this track" data-testid={testId}>
      {done ? <Check className="h-5 w-5" /> : <Share2 className="h-5 w-5" />}{label && <span>{label}</span>}
    </button>
  );
};
